import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="py-12 md:py-16 bg-[#171717] text-[#F8F7F3]/50" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-6">
      <div className="flex flex-col gap-1.5">
        <span
          className="font-heading text-base font-semibold tracking-tight text-[#F8F7F3]/80"
          data-testid="footer-brand-name"
        >
          QUANTIFY
        </span>
        <p className="text-sm" data-testid="footer-tagline">
          Understand your health. Build better habits.
        </p>
        <p className="text-xs text-[#F8F7F3]/45" data-testid="footer-copyright">
          © Synesis Ventures Private Limited
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-5 text-sm text-[#F8F7F3]/70">
        <Link
          to="/privacy-policy"
          data-testid="footer-privacy-policy-link"
          className="transition-[color,transform] duration-300 ease-out hover:text-[#F8F7F3] hover:-translate-y-0.5"
        >
          Privacy Policy
        </Link>
        <Link
          to="/terms-of-service"
          data-testid="footer-terms-of-service-link"
          className="transition-[color,transform] duration-300 ease-out hover:text-[#F8F7F3] hover:-translate-y-0.5"
        >
          Terms of Service
        </Link>
      </div>
    </div>
  </footer>
);
